import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "../FAQ/FAQ.css";
import Loading from "../../Loading/loading";
import API from "../Service/Baseservice";

const FAQView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const faq = location.state?.faq;
    const editor = useRef(null);
    const page = location.state?.page || 1;
    const [formData, setFormData] = useState({
        faqs_id: faq?.faqs_id || "",
        question: faq?.question || "",
        answers: faq?.answers || "",
        category_id: faq?.category_id?.toString() || "",
        status: faq?.status || "active",
        active: faq?.active?.toString() || "1",
    });

    const [loading, setLoading] = useState(true);
    const [categories, setCategories] = useState([]);


    const fetchCategories = () => {
        API.post("faqsCategory_list/condition", {})
            .then((res) => {
                const categoryData = res?.data?.data?.data || [];
                const activeCategories = categoryData.filter(
                    (cat) => cat.active === 1 || cat.active === "1"
                );
                setCategories(activeCategories);
            })
            .catch((err) => console.error("Failed to fetch categories:", err))
            .finally(() => setLoading(false));
    };

    // ✅ Load data
    useEffect(() => {
        if (faq) {
            setFormData({
                faqs_id: faq.faqs_id,
                question: faq.question,
                answers: faq.answers,
                category_id: faq.category_id?.toString(),
                status: faq.status,
                active: faq.active?.toString(),
            });
            fetchCategories();
        } else {
            alert("No FAQ data found. Redirecting...");
            navigate("/faq");
        }
    }, [faq, navigate]);

    if (loading) return <Loading />;

    const categoryName =
        categories.find(
            (cat) => cat.category_id?.toString() === formData.category_id
        )?.category || "Unknown";

    return (
        <div className="news-container">
            <div className="newsadd-container">
                {/* Header */}
                <div className="newsadd-header">
                    <h2 className="newsadd-title">View FAQ</h2>
                    <div className="header-buttons">
                        <button onClick={() => navigate("/faq", { state: { page } })} className="cancel-btn ">
                            Back
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className="newsadd-formcard">
                    {/* Category */}
                    <div className="form-group">
                        <label>Category</label>
                        <input
                            type="text"
                            value={categoryName}
                            readOnly
                            className="readonly-input"
                        />
                    </div>

                    {/* Question */}
                    <div className="form-group">
                        <label>
                            Question <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            type="text"
                            name="question"
                            value={formData.question}
                            readOnly
                            className="readonly-input"
                        />
                    </div>


                    <div className="form-group">
                        <label className="description-label">Answer</label>
                        <div
                        >
                            <CKEditor
                                editor={ClassicEditor}
                                data={formData.answers || ""}
                                disabled={true}

                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQView;
